/* global mixpanel, dataLayer, optimizely */

const EVENT_NAME_GTM_TAG = "eventTracking";

export default class TrackingHelper {
  static trackEvent(category, action, properties = {}, label = "") {
    TrackingHelper.trackMixpanelEvent(action, properties);
    TrackingHelper.trackOptimizelyEvent(action, properties);
    TrackingHelper.trackGtmEvent(category, action, label, properties);
  }

  static trackMixpanelEvent(action, properties) {
    if (typeof mixpanel === "undefined") return;

    mixpanel.track(action, properties);
  }

  static trackGtmEvent(category, action, label, properties) {
    if (typeof dataLayer === "undefined") return;

    dataLayer.push({
      ...properties,
      category,
      action,
      label,
      event: EVENT_NAME_GTM_TAG
    });
  }

  static trackOptimizelyEvent(name, properties) {
    if (typeof optimizely === "undefined") return;

    optimizely.push({
      type: "event",
      eventName: name,
      tags: properties
    });
  }
}
